import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';




import {ApiMessageService} from '../../core/api-message.service';
import {EntitaLocale} from './entitalocale.model';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_ANAGRAFICA} from '../../app-routing.module';


@Injectable()
export class EntitaLocaleService extends CommonService<EntitaLocale> {

  public static ROUTE = 'entitalocale';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): EntitaLocale {
    return JsonBaseBuilder.jsonToEntitaLocale(json);
  }

  public getModule(): string {
    return MODULE_ANAGRAFICA;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return EntitaLocaleService.ROUTE;
  }

  public getTable(items: EntitaLocale[]): Table {
    return Table.buildBaseTable(EntitaLocale.getTableKeys(), items);
  }
}
